const TOKEN_KEY = "token";
const USER_INFO_KEY = "userInfo";

export function getToken() {
  const token = window.localStorage.getItem(TOKEN_KEY);
  return token && token.trim() ? token : "";
}

export function setToken(token) {
  if (!token) {
    clearToken();
    return;
  }
  window.localStorage.setItem(TOKEN_KEY, String(token));
}

export function getUserInfo() {
  const raw = window.localStorage.getItem(USER_INFO_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    // 数据格式异常时清理本地缓存
    window.localStorage.removeItem(USER_INFO_KEY);
    return null;
  }
}

export function setUserInfo(userInfo) {
  if (!userInfo) {
    window.localStorage.removeItem(USER_INFO_KEY);
    return;
  }
  try {
    window.localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
  } catch (e) {
    // 存储异常直接忽略，避免影响正常登录流程
  }
}

export function clearUserInfo() {
  window.localStorage.removeItem(USER_INFO_KEY);
}

export function clearToken() {
  window.localStorage.removeItem(TOKEN_KEY);
  clearUserInfo();
}

export function isLoggedIn() {
  return Boolean(getToken());
}

